import { getEnvironment } from "@/utils/environment.ts";
import { filterFalse } from "@warrenio/utils/collections/filterFalse";

export interface LanguageItem {
    id: string;
    title: string;
}

const hasArr = getEnvironment() !== "production";
const hasPseudo = getEnvironment() !== "production";

// cSpell:disable

/** NB: This is only for the language selector, the actual locales need to be configured elsewhere. */
export const allLanguageItems = filterFalse<LanguageItem>([
    {
        id: "en",
        title: "English",
    },
    {
        id: "et",
        title: "Eesti",
    },
    {
        id: "fr",
        title: "Français",
    },
    {
        id: "fi",
        title: "Suomi",
    },
    {
        id: "bn",
        title: "বাংলা (Bengali)",
    },
    {
        id: "hi",
        title: "आधुनिक मानक हिन्दी (Hindi)",
    },
    {
        id: "id",
        title: "Indonesian",
    },
    {
        id: "th",
        title: "ภาษาไทย (Thai)",
    },
    hasArr && {
        id: "en-x-arr",
        title: "Arr!",
    },
    hasPseudo && {
        id: "zz-pseudo",
        title: "Pseudo-locale",
    },
]);
